import React from "react";
import { HelpCircle } from "lucide-react";
import "../ds/tour.css";

/** The top bar's "?" button: replays the page tour. */
const TourButton: React.FC<{ onClick: () => void }> = ({ onClick }) => (
  <button type="button" className="ds-tour-btn" onClick={onClick} aria-label="Take a tour of this page" title="Take a tour of this page" data-tour="tour-button">
    <HelpCircle aria-hidden="true" strokeWidth={1.75} />
  </button>
);

export default TourButton;
